
import FilterProvider from "./_helper/Filter/FilterProvider";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import { AuthProvider } from "./_helper/Auth/AuthProvider";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
const queryClient = new QueryClient()


const Providers = ({ children }) => (
  
  <AuthProvider >
    <QueryClientProvider client={queryClient}>
    <CustomizerProvider>
      <FilterProvider>
        <AnimationThemeProvider>
          {/* <TourProvider steps={profileTourSteps}> */}
            {children}
          {/* </TourProvider> */}
        </AnimationThemeProvider>
      </FilterProvider>
    </CustomizerProvider>
    </QueryClientProvider>
  </AuthProvider>
);

export default Providers;
